
<section class="hero menu-light">

  <!-- M - GAŁĄZKA - M -->
  <header class="monogram  reveal reveal-from-top">
    <span class="tekst_TheSeasons">M</span>

    <img
      src="../images/galazka.png"
      alt="Gałązka"
      class="galazka"
    >

    <span class="tekst_TheSeasons">M</span>
  </header>


  <!-- GŁÓWNA TREŚĆ -->
  <main class="hero-content">

    <div class="tekst_CG reveal reveal-from-bottom reveal-delay-1">
      BĘDZIE ŚLUB!
    </div>

    <div class="tekst_Cinzel reveal reveal-from-bottom reveal-delay-2">
      17.07.2027
    </div>

    <div class="tekst_CG  reveal reveal-from-bottom reveal-delay-3">
      WROCŁAW
    </div>

    <img
      src="../images/para.png"
      alt="Para"
      class="para"
    >

    <div class="tekst_CG">
      NIE MOŻEMY SIĘ DOCZEKAĆ,
    </div>

    <div class="tekst_CG">
      AŻ BĘDZIECIE ŚWIĘTOWAĆ RAZEM Z NAMI!
    </div>
    <div class="countdown">
      <p 
        id="countdown-title"
        class="countdown-title"
      >
      Do naszego ślubu zostało
      </p>

      <div 
        id="countdown-values"
        class="countdown-values"
      >
        <div class="countdown-item">
          <span id="countdown-days">0</span>
          <small>dni</small>
        </div>

        <span class="countdown-separator">·</span>

        <div class="countdown-item">
          <span id="countdown-hours">0</span>
          <small>godzin</small>
        </div>

        <span class="countdown-separator">·</span>

        <div class="countdown-item">
          <span id="countdown-minutes">0</span>
          <small>minut</small>
        </div>

        <span class="countdown-separator">·</span>

        <div class="countdown-item">
          <span id="countdown-seconds">0</span>
          <small>sekund</small>
        </div>
      </div>
    </div>
  </main>

</section>


<style>

  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap');

  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap');


  /* =========================
     HERO
     ========================= */

  .hero {
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;

    /* miejsce na stałe menu */
    padding-top: 120px;
    padding-bottom: 60px;

    background-color: #ffffff;
  }


  /* =========================
     M - GAŁĄZKA - M
     ========================= */

  .monogram {
    display: flex;
    align-items: center;
    justify-content: center;

    gap: 1.6em;

    margin-bottom: 2em;
  }


  .tekst_TheSeasons {
    font-family: "The Seasons", serif;
    font-size: 3em;
    font-weight: 400;
  }


  .galazka {
    width: 5em;
    height: auto;
  }


  /* =========================
     TREŚĆ HERO
     ========================= */

  .hero-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 1.4em;

    text-align: center;
  }


  .tekst_Cinzel {
    font-family: "Cinzel", serif;

    font-size: 2.4em;
    font-weight: 700;

    letter-spacing: 0.1em;
  }


  .tekst_CG {
    font-family: "Cormorant Garamond", serif;

    font-size: 1.8em;
    font-weight: 400;

    letter-spacing: 0.3em;

    text-align: center;
  }


  .para {
    width: 45em;
    max-width: 90vw;
    height: auto;

    margin: 0.5em 0;
  }


  .countdown {
    margin-top: 2em;
    text-align: center;
  }

  .countdown-title {
    margin: 0 0 0.8em;
    font-family: "Cinzel", serif;
    font-size: 0.9em;
    letter-spacing: 0.12em;
  }

  .countdown-values {
    display: flex;
    justify-content: center;
    gap: 2em;
  }

  .countdown-item {
    display: flex;
    flex-direction: column;
    min-width: 60px;
  }

  .countdown-item span {
    font-family: "Cormorant Garamond", serif;
    font-size: 2em;
    line-height: 1;
  }

  .countdown-item small {
    margin-top: 0.4em;
    font-family: "Cinzel", serif;
    font-size: 0.65em;
    letter-spacing: 0.08em;
  }

  .countdown-separator {
    align-self: flex-start;
    font-family: "Cormorant Garamond", serif;
    font-size: 2em;
    line-height: 1;
  }

  @media (max-width: 600px) {
    .countdown-values {
      gap: 0.8em;
    }

    .countdown-item {
      min-width: 50px;
    }

    .countdown-item span {
      font-size: 1.6em;
    }

    .countdown-item small {
      font-size: 0.55em;
    }
  }

</style>

<script>
  function initCountdown() {
    const weddingDate =
      new Date("2027-07-17T15:15:00+02:00");

    const ceremonyEnd =
      new Date("2027-07-17T16:00:00+02:00");

    const partyEnd =
      new Date("2027-07-18T03:00:00+02:00");

    function updateCountdown() {
      const titleElement =
        document.getElementById("countdown-title");

      const valuesElement =
        document.getElementById("countdown-values");

      const daysElement =
        document.getElementById("countdown-days");

      const hoursElement =
        document.getElementById("countdown-hours");

      const minutesElement =
        document.getElementById("countdown-minutes");

      const secondsElement =
        document.getElementById("countdown-seconds");

      if (
        !(titleElement instanceof HTMLElement) ||
        !(valuesElement instanceof HTMLElement) ||
        !(daysElement instanceof HTMLElement) ||
        !(hoursElement instanceof HTMLElement) ||
        !(minutesElement instanceof HTMLElement) ||
        !(secondsElement instanceof HTMLElement)
      ) {
        return;
      }

      const now = new Date();

      // CEREMONIA
      if (
        now >= weddingDate &&
        now < ceremonyEnd
      ) {
        titleElement.textContent =
          "Ceremonia trwa! 🤍";

        valuesElement.style.display = "none";

        return;
      }

      // WESELE
      if (
        now >= ceremonyEnd &&
        now < partyEnd
      ) {
        titleElement.textContent =
          "Świętujemy! 🥂";

        valuesElement.style.display = "none";

        return;
      }

      // PO ŚLUBIE
      if (now >= partyEnd) {
        titleElement.textContent =
          "Jesteśmy już po ślubie! 🤍";

        valuesElement.style.display = "none";

        return;
      }

      // ODLICZANIE
      titleElement.textContent =
        "Do naszego ślubu zostało";

      valuesElement.style.display = "flex";

      const difference =
        weddingDate.getTime() - now.getTime();

      const days =
        Math.floor(
          difference / (1000 * 60 * 60 * 24)
        );

      const hours =
        Math.floor(
          (difference / (1000 * 60 * 60)) % 24
        );

      const minutes =
        Math.floor(
          (difference / (1000 * 60)) % 60
        );

      const seconds =
        Math.floor(
          (difference / 1000) % 60
        );

      daysElement.textContent =
        String(days);

      hoursElement.textContent =
        String(hours).padStart(2, "0");

      minutesElement.textContent =
        String(minutes).padStart(2, "0");

      secondsElement.textContent =
        String(seconds).padStart(2, "0");
    }

    updateCountdown();

    setInterval(
      updateCountdown,
      1000
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initCountdown
    );
  } else {
    initCountdown();
  }
</script>